import React from 'react';
import { Button, Modal } from 'semantic-ui-react';
import { Flex, Link } from 'rebass';

import { Text } from '../../../Components/Base';
import { getConfig } from '../../../Util/Config';

const ERROR_FORMAT = {
  DUPLICATE_PERSONAL_ID_CARD_NO: { key: 'ER_DUP_ENTRY', message: 'รหัสบัตรประชาชนนี้ถูกใช้ไปแล้ว' },
};

const LinkSchoolErrorModal = ({ open, onClose, locationName, error }) => {
  const lineContactLink = getConfig().lineContactLink;

  const extractErrorMessage = error => {
    if (error) {
      const { DUPLICATE_PERSONAL_ID_CARD_NO } = ERROR_FORMAT;
      const { message } = error;

      if (message.includes(DUPLICATE_PERSONAL_ID_CARD_NO.key)) {
        return DUPLICATE_PERSONAL_ID_CARD_NO.message;
      }
    }
    return `ไม่พบรายชื่อดังกล่าวในระบบโรงเรียน${locationName}`;
  };

  return (
    <Modal size="tiny" open={open} onClose={onClose}>
      <Modal.Header>
        <Text fontWeight={500} fontSize={16}>
          พบข้อผิดพลาด
        </Text>
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Text textAlign="center">{extractErrorMessage(error)}</Text>
          <Flex justifyContent="center" flexDirection="row">
            <Text mr={2}>{`โปรดติดต่อ Line: `}</Text>
            <Link href={lineContactLink} color="primary">
              @tcastermock
            </Link>
            <Text ml={2}>เพื่อตรวจสอบอีกครั้ง</Text>
          </Flex>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          primary
          circular
          content={<span style={{ fontWeight: 400 }}>ปิดหน้าต่าง</span>}
          onClick={onClose}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default LinkSchoolErrorModal;
